import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { getAppInterceptors } from './core/interceptors/interceptor-config';
import { NgSelectModule } from '@ng-select/ng-select';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { LucideAngularModule } from 'lucide-angular';
import { APP_ICONS } from '@shared/constants/icons.const';
import { getMsalProviders } from '@core/config/msal-auth.config';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom([
      BrowserAnimationsModule,
      NgSelectModule,
      LucideAngularModule.pick(APP_ICONS),
    ]),
    provideTranslateService(),
    provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json' }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors(getAppInterceptors())
    ),
    providePrimeNG({
      theme: {
        preset: definePreset(Aura, {
          semantic: {
            primary: {
              50: '{sky.50}',
              100: '{sky.100}',
              200: '{sky.200}',
              300: '{sky.300}',
              400: '{sky.400}',
              500: '{sky.500}',
              600: '{sky.600}',
              700: '{sky.700}',
              800: '{sky.800}',
              900: '{sky.900}',
              950: '{sky.950}',
            },
          },
          primitive: {
            sky: {
              50: '#e8f4f7',
              100: '#c6e3ea',
              200: '#a0d1dc',
              300: '#7abecd',
              400: '#5eb1c3',
              500: '#177991',
              600: '#146e84',
              700: '#115f72',
              800: '#0e5060',
              900: '#083340',
              950: '#041a20',
            },
          },
        }),
        options: {
          prefix: 'p',
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    ...getMsalProviders(),
  ],
};
